import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

const fallbackCopy = (text: string) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  try {
    const successful = document.execCommand('copy');
    return successful;
  } catch {
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
};

export const useCopyToClipboard = () => {
  const { t } = useTranslation();
  const handleCopyToClipboard = useCallback(
    async (text: string, message: string) => {
      let copied = false;
      try {
        await navigator.clipboard.writeText(text);
        copied = true;
      } catch {
        copied = fallbackCopy(text);
      }

      if (copied) {
        toast.success(message);
      } else {
        toast.error(t('errors.copyToClipboard'));
      }
    },
    [t],
  );

  return handleCopyToClipboard;
};
